import React from "react";
import {connect} from "react-redux";
import {Dimensions, FlatList, Modal, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import TendancePopinItem from "./TendancePopinItem";
import FermerPicto from "../Picto/FermerPicto";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

const {width,heigth} = Dimensions.get('screen');

class TendancePopin extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            modalVisible:false,
            timeParution : this.props.timeParution
        }
    }

    setModalVisible = (visible) => {
        this.setState({ modalVisible: visible });
    }

    render() {
        const styles = StyleSheet.create({
            container:{
            },
            container2:{
                backgroundColor:"red",
                justifyContent:"flex-end",
            },
            popinHeader:{
                flexDirection : "row",
                padding:22,
                paddingBottom:15,
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value
            },
            text:{
                fontFamily : this.props.theme.fonts.title,
                color: this.props.theme.colors.tertiary.black1.value,
                fontSize:16,
                width:"90%",
                textAlign:"center"
            },
            v:{

            },
            view:{
                backgroundColor:this.props.theme.colors.primary.White.value,
                justifyContent:"flex-end",
                width:width,
                borderRadius : 12
            },
            view2:{
                flex:1,
                justifyContent:"flex-end",
                backgroundColor:"rgba(0,0,0,0.5)",
                width:width,
                borderRadius : 12
            }
        })
        const data =[
            {
                label : "1 "+this.props.t('jour'),
                value:1
            },
            {
                label : "7 "+this.props.t('jours'),
                value:7
            },
            {
                label : "30 "+this.props.t('jours'),
                value:30
            },

        ];

        return (
            <View style={styles.container}>

            <Modal style={styles.container2} transparent={true} animationType={'slide'} visible={this.props.modalVisible}
                   onRequestClose={() => {
                   }}>
                <View style={styles.view2}>
                <View style={styles.view}>
                    <View style={styles.popinHeader}>
                        <TouchableOpacity onPress={()=>{this.props.setModalVisible(!this.props.modalVisible)}} >
                            <FermerPicto style={{width:15,height:15}} isHeader={true} />
                        </TouchableOpacity>
                        <Text style={styles.text}>{this.props.t('Durée de parution')}</Text>
                    </View>
                    <FlatList style={styles.container} data={data} keyExtractor={(item)=>{return item.value.toString()}} renderItem={ (item) =>{ return <TendancePopinItem setTimeParution={this.props.setTimeParution} timeParution={this.props.timeParution} label={item.item.label} value={item.item.value} key={item.item.value}/> } } />
                </View>
                </View>
            </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(TendancePopin);
